import { Component } from '@angular/core';

import {ModalController, Platform} from '@ionic/angular';
// import { SplashScreen } from '@capacitor/splash-screen';
// import { StatusBar } from '@capacitor/status-bar';
import {User} from "../providers";
import {HomePage} from './home/home.page';
import { interval } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})


export class AppComponent {

  public version;
  public invite;
  public account;
  public unread:number=0;
  public appPages = [
      {
          title: 'قیمت ها',
          url: '/tabs/',
          icon: 'list'
      },{
        title: 'آرامیسگرام',
        url: '/social/',
        icon: 'apps'
    },
      {
        title: 'اینستا جت',
        url: '/instajet',
        icon: 'logo-instagram'
    },{
      title: 'محاسبه گر',
      url: '/calc',
      icon: 'calculator'
    },{
      title: 'درخواست وام',
      url: '/loan',
      icon: 'cash-outline'
    }
//   ,{
//     title: 'تقویم اقتصادی',
//     url: '/ecalendar',
//     icon: 'calendar'
// }
  ];

  constructor(
    private platform: Platform,
    // private splashScreen: SplashScreen,
    // private statusBar: StatusBar,
    public user: User,
    public modalController:ModalController

  ) {
    // SplashScreen.overlaysWebView(false);
    // SplashScreen.show();

      Number.prototype['format'] = function(n, x, s, c) {
          var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
              num = this.toFixed(Math.max(0, ~~n));

          return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
      };
    this.initializeApp();
    this.version = user.account.version;
    const updateCounter = interval(2000);
    updateCounter.subscribe(n => {
        this.unread=Number(localStorage.getItem("unread"))
        })
  }
    async presentHome() {
        const modal = await this.modalController.create({
            component: HomePage,
            // cssClass: 'my-custom-class',
            componentProps: {
                uidkey:this.user.account.userKey,
                img:this.user.account.img,
                name:this.user.account.name,
                owner:true
            }
        });
        await modal.present();
        const { data } = await modal.onWillDismiss();

    }
    async calculator() {
      const modal = await this.modalController.create({
        component: HomePage,
        // cssClass: 'my-custom-class',
        componentProps: {
            uidkey:this.user.account.userKey,
            img:this.user.account.img,
            name:this.user.account.name,
            owner:true
        }
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    }
    exitUser(){
        this.user.clear();
        document.location.href = '/welcome';
    }
    support(){
      window.RocketChat.livechat.maximizeWidget()
      window.RocketChat.livechat.showWidget()
      window.RocketChat.livechat.setGuestToken(this.user.account.mobile);
      window.RocketChat.livechat.setGuestName(this.user.account.name);
      window.RocketChat.livechat.setGuestEmail(`${this.user.account.mobile}@aramis.app`);
      window.RocketChat.livechat.setDepartment('support');
    }
  initializeApp() {
    this.platform.ready().then(() => {
      // this.statusBar.styleDefault();
      // SplashScreen.hide();
      let acc:any=this.user.account
      if (acc.userKey!='' || acc.userKey!=null){
       
        window.RocketChat(function() {
          try{
            
          if(acc.configed!=='true'){
            this.setLanguage('fa');
            this.setGuestName(acc.name);
            this.setGuestEmail(`${acc.mobile}@aramis.app`);
            this.setDepartment('support');
            this.setGuestToken(acc.mobile);
            window.localStorage.setItem('configed', 'true');
          }
          }catch{
            console.log("ch error")
          }
        });
        
      }
      
    });
  }
  sendInVite(){
        this.invite=this.user.convertPersianNum(this.invite)
        if (!/^09\d{9}$/.test(this.invite)){
          this.user.myToast("شماره تماس صحیح نمی باشد")
          return false
        }
        this.user.myLoading()
        const formData = new FormData();
        formData.append("userKey", this.user.account.userKey);
        formData.append("vr", this.user.account.version);
        formData.append("phone", this.user.convertPersianNum(this.invite));
        this.user.api.post("crm/inviteFirend" ,formData).subscribe(mres => {
          this.user.dismissLoading();
          this.user.myAlert(mres["message"])
          this.invite=""
         },err=>{          
            this.user.dismissLoading();
        });
  }
}
